<template>
  <div class="recallMsg">
    <div class="projectList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
      <i style="display: inline-block; margin-right: 20px"></i>
      <a-button type="primary" @click="add">新增</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="tablePagination"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.id"
    >
      <span slot="action" slot-scope="text, record">
        <a href="javascript:;" @click="editClick(record)">修改</a>
        <a-divider type="vertical" />
        <a-popconfirm
          placement="right"
          okText="确认"
          cancelText="取消"
          @confirm="deleteClick(record.id)"
        >
          <template slot="title">是否确认删除{{ record.name }}</template>
          <a href="javascript:;" style="color: #ff4d4f">删除</a>
        </a-popconfirm>
      </span>
    </a-table>
    <a-modal
      :title="title"
      v-model="addKeyVisible"
      :maskClosable="false"
      class="action-class"
      width="500px"
    >
      <a-form>
        <a-form-item
          label="名称:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            placeholder="请输入名称"
            v-model="nameAdd"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item
          label="域名:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            placeholder="请输入域名"
            v-model="domainAdd"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item
          label="跳转路径:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            placeholder="请输入跳转路径"
            v-model="pathAdd"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item
          label="短信内容:"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-textarea
            v-model="msgContentAdd"
            placeholder="请输入短信内容"
            :rows="5"
          />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <div style="display: flex; justify-content: center">
          <a-button key="back" @click="addKeyVisible = false">取消</a-button>
          <a-button key="submit" type="primary" @click="add_submit"
            >确定</a-button
          >
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
import api from "../lib/recall.js";

export default {
  name: "recallMsg",
  data() {
    return {
      pageNo: 1,
      tableColumns: [
        {
          title: "编号",
          dataIndex: "id",
          width: 60,
        },
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "域名",
          dataIndex: "domain",
        },
        {
          title: "跳转路径",
          dataIndex: "path",
        },
        {
          title: "短信内容",
          dataIndex: "msgContent",
          width: 300,
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      tableDataSource: [],
      tablePagination: {},
      loadingTable: false,
      addKeyVisible: false,
      title: "新增",
      nameAdd: "",
      domainAdd: "",
      pathAdd: "",
      msgContentAdd: "",
      id: "",
    };
  },
  mounted() {
    this.query(1);
    this.getTypeList();
  },
  methods: {
    editClick(val) {
      this.title = "修改";
      this.id = val.id;
      this.nameAdd = val.name;
      this.domainAdd = val.domain;
      this.pathAdd = val.path;
      this.msgContentAdd = val.msgContent;
      this.addKeyVisible = true;
    },
    deleteClick(id) {
      api.recallTypeDelete({ id }).then((res) => {
        if (res.result == 200) {
          this.$message.success("删除成功");
          this.query();
        }
      });
    },
    add() {
      this.title = "新增";
      this.nameAdd = "";
      this.domainAdd = "t4g.cn";
      this.pathAdd = "/pages/home/home";
      this.msgContentAdd = "";
      this.addKeyVisible = true;
    },
    add_submit() {
      let data = {
        name: this.nameAdd,
        domain: this.domainAdd,
        msgContent: this.msgContentAdd,
        path: this.pathAdd,
      };
      if (this.title == "新增") {
        api.recallTypeAdd(data).then((res) => {
          if (res.result == 200) {
            this.$message.success("新增成功");
            this.addKeyVisible = false;
            this.query();
          }
        });
      } else {
        data.id = this.id;
        api.recallTypeEdit(data).then((res) => {
          if (res.result == 200) {
            this.$message.success("修改成功");
            this.addKeyVisible = false;
            this.query();
          }
        });
      }
    },
    // 点击查询
    query(index) {
      if (index) {
        this.pageNo = index;
      }
      let data = {
        pageSize: 10,
        pageNo: this.pageNo,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .recallTypePage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            this.tableDataSource = res.data.records;
            this.tablePagination = {
              showQuickJumper: true,
              showTotal: () => `共${res.data.total}条`,
              pageSize: data.pageSize,
              current: data.pageNo,
              total: res.data.total,
              onChange: (current) => this.changePageItem(current),
            };
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
    changePageItem(index) {
      this.query(index);
    },
  },
};
</script>
<style lang="scss" scoped>
.recallMsg {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .backup {
      padding: 5px 0;
    }
    span {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .projectList-search-button {
    margin-bottom: 20px;
    button {
      margin-right: 20px;
    }
    .request_nav_item {
      display: inline-block;
      margin-right: 20px;
      width: 350px;
      input {
        width: 250px;
      }
      .ant-select {
        width: 250px;
      }
    }
  }
}
</style>
